const updateSelectionHash = (newParams) => {
  const currentHash = window.location.hash.replace('#', '');
  const params = new URLSearchParams(currentHash);

  Object.keys(newParams).forEach((key) => {
    if (newParams[key]) {
      params.set(key, newParams[key]);
    } else {
      params.delete(key);
    }
  });

  window.history.pushState({}, '', `#${params.toString()}`);
};

export default updateSelectionHash;
